import i18next from 'i18next';

import { PaymentMethodError } from '@errors';
import type { AxiosErrorResponseType } from '@api';

type ParsedApiErrorType = {
  message: string;
  errorCode?: number;
  status?: number;
};

// TODO: consider option to replace it by common parseError
export function parseApiError(error: unknown): ParsedApiErrorType {
  if (error instanceof PaymentMethodError) {
    let message;

    // Only for card errors, these messages can be shown to your users
    if (error.type === 'card_error') {
      message = error.message;
    }

    return {
      message: message ?? i18next.t('errors.default'),
    };
  }

  if ((error as AxiosErrorResponseType).isAxiosError) {
    const err = error as AxiosErrorResponseType;

    let message;

    if (err.isNetworkError) {
      message = i18next.t('errors.network');
    } else if (err.response && err.response.status > 500) {
      message = i18next.t('errors.service');
    } else if (err.response && err.response.data.errorCode === 96) {
      // 96 - refresh token expired or invalid
      message = i18next.t('errors.unauthorized');
    } else if (err.response && err.response.data.errorCode === 91) {
      // 91 - user is deleted
      message = i18next.t('errors.userDeleted');
    } else {
      message = err.response?.data.message;
    }

    return {
      errorCode: err.response?.data.errorCode,
      status: err.response?.data.statusCode,
      message: message ?? i18next.t('errors.default'),
    };
  }

  return {
    message: i18next.t('errors.default'),
  };
}
